import React from 'react';
import { IconClear1 } from '@axafr-btc-ds/icons';
import { ColorToken } from '@axafr-btc-ds/colors';
export var Close = function (_a) {
    var className = _a.className, closeButtonAriaLabel = _a.closeButtonAriaLabel, pictoClassName = _a.pictoClassName, onClose = _a.onClose;
    var handleOnKeyDown = function (event) {
        if (['Enter', 'Space', 'Escape'].includes(event.code)) {
            onClose(event);
        }
    };
    return (React.createElement("button", { type: "button", className: className, onClick: onClose, onKeyDown: handleOnKeyDown, "aria-label": closeButtonAriaLabel },
        React.createElement(IconClear1, { color: ColorToken.iconSecondary, className: pictoClassName })));
};
